<template>
  <div class="timer-small"
       :class="{
         '_accent': +days < 3,
         '_simple': simple
       }"
  >
    <template v-if="simple">
      <template v-if="endTime !== undefined">
        <span>{{days}}</span> : <span>{{hours}}</span> : <span>{{minutes}}</span>
      </template>
      <template v-else>
        <span>-</span> : <span>-</span> : <span>-</span>
      </template>
    </template>

    <template v-else>
      <template v-if="endTime !== undefined">
        <div class="timer-small__col">
          <div class="timer-small__val">{{days}}</div>
          <div class="timer-small__label">{{$tGlobal('days', +days)}}</div>
        </div>
        <div class="timer-small__col">
          <div class="timer-small__val">{{hours}}</div>
          <div class="timer-small__label">{{$tGlobal('hours', +hours)}}</div>
        </div>
        <div class="timer-small__col">
          <div class="timer-small__val">{{minutes}}</div>
          <div class="timer-small__label">{{$tGlobal('minutes', +minutes)}}</div>
        </div>
      </template>
      <template v-else>
        <div class="timer-small__col">-</div>
        <div class="timer-small__col">-</div>
        <div class="timer-small__col">-</div>
      </template>
    </template>

  </div>
</template>

<script>
  import parseDate from "../helpers/parseDate";

  export default {
    name: "TimerSmall",
    props: {
      endTime: {
        type: [Date, String, Number],
      },
      simple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        timer: null,
        timeDiff: 0
      }
    },
    computed: {
      endTimeMS() {
        return +(parseDate(this.endTime))
      },
      days() {
        const totalM = this.timeDiff / 1000 / 60
        return Math.floor(totalM / 60 / 24).toString().padStart(2, '0')
      },
      hours() {
        const totalM = this.timeDiff / 1000 / 60
        return Math.floor(totalM / 60 % 24).toString().padStart(2, '0')
      },
      minutes() {
        const totalM = this.timeDiff / 1000 / 60
        return Math.ceil(totalM % 60).toString().padStart(2, '0')
      }
    },
    methods: {
      createTimer() {
        clearInterval(this.timer)
        if(this.endTime === undefined) return

        this.setDif()
        this.timer = setInterval(() => {
          this.setDif()
        }, 1000)
      },
      setDif() {
        let currentTime = +(new Date())
        this.timeDiff = (new Date(this.endTimeMS) - currentTime) || 0

        if (this.timeDiff <= 0) {
          this.timeDiff = 0
          clearInterval(this.timer)
        }
      }
    },
    watch: {
      endTime() {
        this.createTimer()
      }
    },
    created() {
      this.createTimer()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>

<style>

</style>
